export default __webpack_public_path__ + "static/media/AssortmentSelection.df0aea61.png";